<template>
    <HeaderComponent title="Users" :show-back-button="false" :actions="[
        {label: 'Add User', click: () => router.get('/admin/users/add'), class: 'bg-blue-500 text-white'},
    ]"/>
    <DataTable :value="users" tableStyle="min-width: 50rem">
        <Column field="id" header="ID"></Column>
        <Column field="full_name" header="Name"></Column>
        <Column field="username" header="Username"></Column>
        <Column header="Affiliates">
            <template #body="slotProps">
                {{
                    slotProps.data.affiliates.length > 0
                        ? slotProps.data.affiliates
                              .map((affiliate) => affiliate.name)
                              .join(", ")
                        : "-"
                }}
            </template>
        </Column>
        <Column header="">
            <template #body="slotProps">
                <Link
                    :href="`/admin/users/edit/${slotProps.data.id}`"
                    class="hover:text-blue-500 hover:scale-105 transition-all duration-300 cursor-pointer"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30px"
                        height="30px"
                        viewBox="0 0 24 24"
                    >
                        <path
                            fill="currentColor"
                            d="M5 19h1.425L16.2 9.225L14.775 7.8L5 17.575zm-2 2v-4.25L16.2 3.575q.3-.275.663-.425t.762-.15t.775.15t.65.45L20.425 5q.3.275.438.65T21 6.4q0 .4-.137.763t-.438.662L7.25 21zM19 6.4L17.6 5zm-3.525 2.125l-.7-.725L16.2 9.225z"
                        ></path>
                    </svg>
                </Link>
            </template>
        </Column>
    </DataTable>
</template>

<script setup>
import { usePage, router, Link } from "@inertiajs/vue3";
import { computed } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import HeaderComponent from "@/Components/HeaderComponent.vue";

const page = usePage();

const users = computed(() => page.props.users);
</script>
